import { ApplicationStatus, TOnSignFileData } from 'components/DocBox/DocBox.types';
import {
    AdvisoryData,
    ApplicationDocumentType,
    Documents,
} from '../../components/ApplicationDetails/AdvisorySection/AdvisorySection.types';
import { SingleApplicationData } from '../../components/ApplicationDetails/Applications/Applications.types';

export enum ApplicationDetailsActionTypes {
    UPDATE_GENERATE_APPLICATION_DOC = 'UPDATE_GENERATE_APPLICATION_DOC',
    SET_APPLICATIONS = 'SET_APPLICATIONS',
    UPDATE_APPLICATION_STATUS = 'UPDATE_APPLICATION_STATUS',
    ADD_GENERATED_DOCS_FOR_APPLICATION = 'ADD_GENERATED_DOCS_FOR_APPLICATION',
    UPDATE_APPLICATION_DOC = 'UPDATE_APPLICATION_DOC',
    UPDATE_APPLICATION_DOC_WITH_TRANSFER = 'UPDATE_APPLICATION_DOC_WITH_TRANSFER',
    UPDATE_PROOF_OF_ASSETS_DOC = 'UPDATE_PROOF_OF_ASSETS_DOC',
    SET_PROOF_OF_ASSETS_DOCS = 'SET_PROOF_OF_ASSETS_DOCS',
    SET_BASIC_AGREEMENT_DOCS = 'SET_BASIC_AGREEMENT_DOCS',
    UPDATE_BASIC_AGREEMENT_DOC = 'UPDATE_BASIC_AGREEMENT_DOC',
    SUBMIT_APPLICATION = 'SUBMIT_APPLICATION',
    SET_ID_DOCUMENTS = 'SET_ID_DOCUMENTS',
    UPDATE_ID_DOCUMENTS = 'UPDATE_ID_DOCUMENTS',
}

export type JAUsersType = {
    id: number;
    fullName: string;
} [];

export type TApplicationDetailsManagerState = {
    proofOfAssetDocuments: Documents;
    basicAgreementDocuments: Documents;
    idDocuments: Documents;
    applicationsData: SingleApplicationData[],
}

export type EmptyFormsDocument = {
    dmsMetadataReferenceId: string;
    documentName: string;
}

export type IdDocumentType = ApplicationDocumentType[];

export type TApplicationDetailsManager = TApplicationDetailsManagerState & {
    isJA: boolean,
    jaUsers?: JAUsersType,
    advisoryData: AdvisoryData,
    advisoryDocument: ApplicationDocumentType,
    isAdvisoryExpired: boolean,
    isAdvisoryCase: boolean,
    isWithdrawalPlanChange?: boolean,
    isAdvisoryDocReadyForSubmission: boolean,
    isAllApplicationCancellable: boolean,
    isApplicationsLoading: boolean,
    hasDocumentESignAccess?: boolean;
    cancelAllApplications: () => Promise<() => void>,
    cancelApplication: (payload: {applicationId: number}) => Promise<void>,
    submitApplication: (payload: {applicationId: number, planType: string, productExternalId?: string}) => Promise<void | null> | null,
    acceptDocumentSend: (payload: {documentId: number}) => Promise<void>,
    onManualSign: (d:TOnSignFileData) => Promise<void>;
    onESign: (d: { documentId: number }) => Promise<void>;
    onDocGeneration?: (d: { applicationId: number; applicationStatus?: ApplicationStatus; is3aVB?: boolean; }) => Promise<void>;
    onDocGenerationWithNewAPI?: (d: { applicationId: number; applicationStatus?: ApplicationStatus; is3aVB?: boolean; }) => Promise<void>;
    setRetryState: (d: { applicationId: number }) => void
    showGeneralDocumentsAndProofOfAssetsSection?: boolean;
    isAllIdDocumentsSigned?: boolean;
    emptyFormDocuments?: EmptyFormsDocument[];
    idDocuments: IdDocumentType;
    onIdDocumentUpload: (d: { userId: number, docData: TOnSignFileData }) => Promise<void>;
    apiError?: { message: string } | null;
    isFollowUpInvestorProfileCase?: boolean;
    canReUploadAdvisoryDocs?: boolean;
    showCanNotSubmitApplicationMessage?: boolean;
    canCompleteFollowUpInvestorProfileApplication?: boolean;
    advisoryDocSubmittedForReview?: boolean;
    hasAccessToReUpload?: boolean;
    is3BDocGenerationInProgress?: boolean;
    isUploadedAdvisory?: boolean;
    setAdvisoryDocSubmittedForReview: (val: boolean) => void;
    onAdvisoryDocReUpload?: ({
        filename, file, containerId,
    } : {
        filename: string;
        file: File;
        containerId?: string;
    }) => void;
}
